/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ContextNodeWithFullContextViewer} from "../../../Components/Common/ContextNodeWithFullContextViewer";
import React from "react";

export function ContextNodeFieldViewer(props) {

	var bootstrappedContextNode = null;
	const {FieldDef, Value, RootData, Data} = props;
	
	if (FieldDef &&
		FieldDef.associationName &&
		Data &&
		Data[FieldDef.associationName] &&
		Data[FieldDef.associationName].ContextNode &&
		Data[FieldDef.associationName].ContextNode) {
		bootstrappedContextNode = Data[FieldDef.associationName].ContextNode;
	}

	return <span>
            <ContextNodeWithFullContextViewer
	            ContextNodeId={Value}
	            UserRoleId={RootData.userRoleId}
	            ContextNode={bootstrappedContextNode}
            />
        </span>;
}